import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=b4653570&scoped=true&"
import script from "./Playlist.vue?vue&type=script&lang=js&"
export * from "./Playlist.vue?vue&type=script&lang=js&"
import style0 from "./Playlist.vue?vue&type=style&index=0&id=b4653570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4653570",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/Playlist.vue
// module id = null
// module chunks = 